module.exports = __webpack_public_path__ + "static/media/couches-5.8368cd46.jpg";